module.exports = __webpack_public_path__ + "epaper-e628acaae949fe068003.png";